export const RECAPTCHA_SCRIPT_URL = 'https://www.google.com/recaptcha/api.js?render=';

// render=onload turns off auto-rendering: the widget is rendered by the hook.
export const YANDEX_CAPTCHA_SCRIPT_URL = 'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload';
export const YANDEX_CAPTCHA_SITE_KEY = 'ysc1_xGKAFyr7YZ7cO2c8sGUfCMAqow0C8hdIxQGCWunM31514b34';

// Placeholder token for dev environments, where the captcha is disabled on the
// backend as well (recaptcha_disabled in single-sign-on).
export const RECAPTCHA_DEV_TOKEN = 'dev-recaptcha-disabled';

// Names the key pair: the backend picks the secret up front, because the
// token is spent by the first siteverify (AIDEV-2771).
export const RECAPTCHA_VERSION = 'v3';

// Wavesend cannot load Google scripts; the backends verify these tokens with Yandex.
export const YANDEX_CAPTCHA_VERSION = 'yandex';

// Mirrored in accounts/api/single-sign-on (internal/recaptcha) and
// accounts/api/user: a token minted for another action is rejected.
export const RECAPTCHA_ACTIONS = {
  login: 'login',
  ssoCheck: 'sso_check',
  register: 'register',
} as const;
